import { useDispatch, useSelector } from "react-redux";
import { logout } from "../app/Actions/auth";
import { authAxios } from "../api/axiosClient";
import { logoutURL } from "../constants";
import React, { useState } from "react";
import { Sidebar } from "./Sidebar";
import { Col, Input, Modal, Form, Row, Button, Alert, Avatar } from "antd";
import { CloseCircleOutlined, UserOutlined } from "@ant-design/icons";
import { PutChangePassApi, CheckUserHomeApi } from "../api/usersApi";
import { openNotificationWithIcon } from "./Function";
import Cookies from "universal-cookie";

const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const cookies = new Cookies();

export const Navbar = () => {
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);
  const [modalVisiblePass, setModalVisiblePass] = useState(false);
  const [loading, setLoading] = useState(false);
  const logout_new = (e) => {
    authAxios()
      .get(logoutURL)
      .then((res) => {
        cookies.remove("token");
        cookies.remove("refresh");
        // cookies.remove('sessionid');

        window.location = "/login";
      });

    logout();
  };

  const fetchApiChangePass = (params = {}) => {
    setLoading(true);
    PutChangePassApi(userInfo.id, {
      password: params.pass_new2,
    })
      .then((res) => {
        if (res.data.error) {
          const dataError = Object.entries(res.data.error).map(
            ([key, value]) => value,
          );
          openNotificationWithIcon("error", "Lỗi", dataError);
          setModalVisiblePass(false);
        } else {
          openNotificationWithIcon(
            "success",
            "Thông báo",
            "Đổi mật khẩu thành công.",
          );
          setModalVisiblePass(true);
          logout_new();
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onFinishChangePass = (values) => {
    if (
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()])[A-Za-z\d~`!@#$%^&*()]{9,}$/.test(
        values.passNew_1,
      ) == false
    ) {
      openNotificationWithIcon("error", "Lỗi", "Mật khẩu không hợp lệ.");
      return;
    } else {
      setLoading(true);
      fetchApiChangePass({
        pass_new2: values.passNew_2,
      });
    }
  };

  const handleModalCancel_1 = () => {
    setModalVisiblePass(false);
  };

  const check_user_home = (e) => {
    CheckUserHomeApi({
      username: userInfo.username,
      msnv: userInfo.msnv,
      key_pass: "A0ZE7dtaCWvrEvX3Ybl811Q-3jo",
    })
      .then((res) => {
        if (res.data.error) {
          const dataError = Object.entries(res.data.error).map(
            ([key, value]) => value,
          );
          openNotificationWithIcon("error", "Lỗi", dataError);
        } else {
          if ("result" in res.data) {
            if (res.data.result == "Không tồn tại user") {
              setModalVisiblePass(true);
              return true;
            }
          }
          openNotificationWithIcon(
            "info",
            "Thông báo",
            "Vui lòng đổi mật khẩu tại trang chủ (https://homepage.rainscales.com.vn/)",
          );
        }
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon(
          "error",
          "Lỗi",
          "Lỗi hệ thống, vui lòng kiểm tra lại.",
        );
      });
  };

  const ChangePass = (modalVisiblePass) => {
    return (
      <Modal
        destroyOnClose
        title="Đổi mật khẩu"
        visible={modalVisiblePass}
        onCancel={handleModalCancel_1}
        footer={null}
        closeIcon={<CloseCircleOutlined title="Thoát (ESC)" />}
        keyboard // press esc to close
        width={600}
      >
        <Form
          onFinish={(values) => onFinishChangePass(values)}
          validateMessages={validateMessages}
          layout="vertical"
        >
          <Col sm={13} offset={4}>
            <Form.Item
              name="passOLD"
              rules={[
                {
                  required: true,
                },
              ]}
              label={"Nhập mật khẩu cũ"}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col sm={13} offset={4}>
            <Form.Item
              name="passNew_1"
              rules={[
                {
                  required: true,
                },
              ]}
              label={"Nhập mật khẩu mới"}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col sm={13} offset={4}>
            <Form.Item
              name="passNew_2"
              label={"Nhập lại mật khẩu mới"}
              dependencies={["passNew_1"]}
              hasFeedback
              rules={[
                {
                  required: true,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("passNew_1") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Hai mật khẩu bạn đã nhập không khớp!"),
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Row style={{ paddingBottom: "5px" }}>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                shape="round"
                size="default"
                type="primary"
                htmlType="submit"
              >
                Đổi mật khẩu
              </Button>
            </Col>
          </Row>
        </Form>
        <Row>
          <Alert
            message="Lưu ý: "
            description="Mật khẩu phải ít nhất 9 ký tự bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt."
            type="warning"
            showIcon
          />
        </Row>
      </Modal>
    );
  };

  return (
    <>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <a
                href="https://homepage.rainscales.com.vn/"
                className="logo logo-dark"
              >
                <span className="logo-sm">
                  <img
                    src="/logo_new/AI-white.png"
                    alt="Rainscales"
                    height="36"
                  />
                </span>
                <span className="logo-lg">
                  <img
                    src="/logo_new/Rainscales-logo-white.png"
                    alt="Rainscales"
                    height="70"
                  />
                </span>
              </a>

              <a
                href="https://homepage.rainscales.com.vn/"
                className="logo logo-light"
              >
                <span className="logo-sm">
                  <img
                    src="/logo_new/AI-white.png"
                    alt="Rainscales"
                    height="36"
                  />
                </span>
                <span className="logo-lg">
                  <img
                    src="/logo_new/Rainscales-logo-white.png"
                    alt="Rainscales"
                    height="70"
                  />
                </span>
              </a>
            </div>
            <Sidebar />
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon waves-effect"
                id="page-header-search-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="mdi mdi-magnify"></i>
              </button>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="dropdown d-inline-block ">
              <button
                type="button"
                className="btn header-item waves-effect noti-icon "
                id="page-header-user-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {/* <img className="rounded-circle header-profile-user"
                                     src={userInfo.avatar_url ? userInfo.avatar_url : "/assets/images/users/avatar-1.jpg"}
                                     alt="Header Avatar"/> */}
                {userInfo.avatar_url ? (
                  <Avatar
                    src={userInfo.avatar_url}
                    className="rounded-circle header-profile-user"
                  />
                ) : (
                  <UserOutlined />
                )}{" "}
                <span className="d-none d-xl-inline-block ms-1" key="t-henry">
                  {userInfo.username}
                </span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </button>
              <div className="dropdown-menu dropdown-menu-end styleDropMenu">
                <a
                  className="dropdown-item d-block"
                  onClick={() => check_user_home()}
                >
                  <i className="mdi mdi-key-change font-size-16 align-middle me-1"></i>
                  <span key="t-settings">Đổi mật khẩu</span>
                </a>
                <a
                  className="dropdown-item text-danger"
                  onClick={() => logout_new()}
                >
                  <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
                  <span key="t-logout">Đăng xuất</span>
                </a>
                {ChangePass(modalVisiblePass)}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
